import * as React from "react";
const BrandPromotionSVG = (props) => (
  <svg
    className="animated"
    id="freepik_stories-brand-construction"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <style>
      {
        "svg#freepik_stories-brand-construction:not(.animated) .animable {opacity: 0;}svg#freepik_stories-brand-construction.animated #freepik--background-complete--inject-120 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-brand-construction.animated #freepik--Shadow_2--inject-120 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-brand-construction.animated #freepik--Speech_Bubble--inject-120 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-brand-construction.animated #freepik--Character_2--inject-120 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-brand-construction.animated #freepik--Blocks--inject-120 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn,1.5s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-brand-construction.animated #freepik--Shadow_1--inject-120 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-brand-construction.animated #freepik--Character_1--inject-120 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn,1.5s Infinite  linear floating;animation-delay: 0s,1s;}            @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }                    @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        "
      }
    </style>
    <g
      id="freepik--background-complete--inject-120"
      className="animable"
      style={{
        transformOrigin: "250px 251.724px",
      }}
    >
      <g
        id="el8kxe03n7695"
        className="animable"
        style={{
          transformOrigin: "250px 224.471px",
        }}
      >
        <g
          id="elzync78w4s7"
          className="animable"
          style={{
            transformOrigin: "250px 212.693px",
          }}
        >
          <g
            id="el81fiv6uam7j"
            className="animable"
            style={{
              transformOrigin: "249.333px 182.034px",
            }}
          >
            <path
              d="M443.92,319.532h-180.746c-3.232,0-5.862-2.63-5.862-5.862V50.397c0-3.232,2.63-5.862,5.862-5.862h180.746c3.232,0,5.862,2.629,5.862,5.862V313.67c0,3.233-2.63,5.862-5.862,5.862ZM263.174,44.785c-3.095,0-5.612,2.518-5.612,5.612V313.67c0,3.095,2.518,5.612,5.612,5.612h180.746c3.095,0,5.612-2.517,5.612-5.612V50.397c0-3.094-2.518-5.612-5.612-5.612h-180.746Z"
              style={{
                fill: "rgb(224, 224, 224)",
                transformOrigin: "353.547px 182.034px",
              }}
              id="elza2qyc8ovu"
              className="animable"
            />
            <path
              d="M235.493,319.532H54.746c-3.232,0-5.862-2.63-5.862-5.862V50.397c0-3.232,2.629-5.862,5.862-5.862H235.493c3.232,0,5.862,2.629,5.862,5.862V313.67c0,3.233-2.63,5.862-5.862,5.862ZM54.746,44.785c-3.094,0-5.612,2.518-5.612,5.612V313.67c0,3.095,2.518,5.612,5.612,5.612H235.493c3.095,0,5.612-2.517,5.612-5.612V50.397c0-3.094-2.518-5.612-5.612-5.612H54.746Z"
              style={{
                fill: "rgb(224, 224, 224)",
                transformOrigin: "145.119px 182.034px",
              }}
              id="elwyym8xj9lwa"
              className="animable"
            />
          </g>
          <rect
            x={0}
            y={380.602}
            width={500}
            height={0.25}
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "250px 380.727px",
            }}
            id="elfiwknzg7dn"
            className="animable"
          />
        </g>
        <rect
          x={51.672}
          y={394.867}
          width={16.06}
          height={0.25}
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "59.702px 394.992px",
          }}
          id="elewgoqzt5bpo"
          className="animable"
        />
        <rect
          x={170.352}
          y={392.156}
          width={53.53}
          height={0.25}
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "197.117px 392.281px",
          }}
          id="eld5d1spwslpq"
          className="animable"
        />
        <rect
          x={68.732}
          y={404.156}
          width={36.25}
          height={0.25}
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "86.857px 404.281px",
          }}
          id="elb8vhih6u6o"
          className="animable"
        />
        <rect
          x={378.352}
          y={392.026}
          width={43.19}
          height={0.25}
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "399.947px 392.151px",
          }}
          id="elcznt96jv5z"
          className="animable"
        />
        <rect
          x={430.452}
          y={392.026}
          width={6.33}
          height={0.25}
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "433.617px 392.151px",
          }}
          id="elgnitti0s8iq"
          className="animable"
        />
        <rect
          x={316.212}
          y={398.256}
          width={53.89}
          height={0.25}
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "343.157px 398.381px",
          }}
          id="elonjgg3p0c8h"
          className="animable"
        />
      </g>
      <g
        id="elia6mcv77yb"
        className="animable"
        style={{
          transformOrigin: "411.947px 410.524px",
        }}
      >
        <g
          id="elenkim94hxio"
          className="animable"
          style={{
            transformOrigin: "410.592px 409.055px",
          }}
        >
          <path
            d="M409.798,438.748c-.013-.391-1.33-39.271-7.654-45.42-6.151-5.979-13.21-.222-13.507,.025l-.634-.76c.08-.068,8.047-6.571,14.831,.025,6.608,6.426,7.901,44.481,7.952,46.098l-.989,.031Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "399.395px 414.206px",
            }}
            id="elhfrabudruc7"
            className="animable"
          />
          <path
            d="M410.341,446.389c-.045-.465-4.322-46.675,12.554-66.042l.746,.649c-16.596,19.047-12.359,64.836-12.315,65.296l-.985,.097Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "416.733px 413.368px",
            }}
            id="el78i40k0uqjg"
            className="animable"
          />
          <path
            d="M409.717,441.501l-.988-.066c.035-.524,3.303-52.534-9.076-63.919l.67-.729c12.726,11.705,9.536,62.555,9.394,64.714Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "404.913px 409.144px",
            }}
            id="elsqdyp2ssjwi"
            className="animable"
          />
          <path
            d="M411.328,441.472l-.99-.008c.012-1.432,.408-35.13,9.98-40.616,2.128-1.221,4.211-1.424,6.193-.604,5.788,2.394,8.656,12.695,8.775,13.132l-.955,.261c-.028-.103-2.86-10.271-8.2-12.479-1.683-.695-3.473-.511-5.322,.548-9.083,5.205-9.48,39.42-9.483,39.765Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "422.812px 420.611px",
            }}
            id="eln66mmemnxxo"
            className="animable"
          />
          <path
            d="M407.601,441.496l-.988-.056c.015-.266,1.444-26.629-5.671-35.918-1.724-2.25-3.595-3.323-5.572-3.185-4.662,.326-8.571,7.148-8.61,7.217l-.862-.487c.17-.3,4.208-7.353,9.401-7.716,2.323-.165,4.489,1.038,6.429,3.571,7.338,9.58,5.936,35.478,5.873,36.576Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "396.823px 421.417px",
            }}
            id="el3rfv2ei6sv1"
            className="animable"
          />
          <path
            d="M409.161,445.082c-.194-2.558-4.651-62.755,3.192-73.362l.795,.588c-7.626,10.315-3.047,72.076-3,72.699l-.987,.075Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "410.437px 408.401px",
            }}
            id="elbfzn05ssa8m"
            className="animable"
          />
        </g>
        <path
          d="M428.645,406.345s-4.705,1.734-3.306,5.829c1.399,4.095,16.276,10.835,16.276,10.835,0,0,6.231-5.711,.509-14.999-5.722-9.288-13.352-4.595-13.479-1.664Z"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "434.81px 412.769px",
          }}
          id="elao47ob09z1t"
          className="animable"
        />
        <path
          d="M408.192,398.55s5.01-.21,5.295,4.108c.285,4.318-10.854,16.264-10.854,16.264,0,0-7.949-2.874-6.242-13.649,1.707-10.775,10.556-9.379,11.801-6.723Z"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "404.822px 407.793px",
          }}
          id="elyyaogq7oh8e"
          className="animable"
        />
        <path
          d="M403.95,377.88s3.34-.359,3.071-2.393c-.269-2.035-12.985-7.271-20.488,1.196,0,0,4.804,8.252,11.748,8.36,6.944,.108,5.668-7.163,5.668-7.163Z"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "396.785px 378.529px",
          }}
          id="eljdd4lq4eqnf"
          className="animable"
        />
        <path
          d="M410.174,372.939s-3.024,1.463-3.872-.406c-.848-1.869,7.175-13.039,18.021-9.82,0,0,.287,9.544-5.549,13.309-5.836,3.765-8.599-3.082-8.599-3.082Z"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "415.283px 369.643px",
          }}
          id="elmz7vbzr4rq"
          className="animable"
        />
        <path
          d="M394.359,404.699s2.305-1.861-.183-2.77c-2.488-.909-14.695-.65-14.823,11.442,0,0,14.218,2.363,15.978-2.243,1.76-4.606-.972-6.429-.972-6.429Z"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "387.637px 407.793px",
          }}
          id="el589qm1vsxch"
          className="animable"
        />
        <path
          d="M423.352,377.577s-2.305-1.861,.183-2.77c2.488-.909,14.695-.65,14.822,11.442,0,0-14.218,2.363-15.978-2.243-1.76-4.606,.973-6.429,.973-6.429Z"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "430.073px 380.671px",
          }}
          id="elubd6jm1cyqn"
          className="animable"
        />
        <path
          d="M415.836,387.318s-.203-2.263,1.624-1.376,8.191,7.753,1.594,14.268c0,0-8.88-6.577-7.279-10.002,1.601-3.425,4.062-2.89,4.062-2.89Z"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "416.781px 392.973px",
          }}
          id="elq6bjh1jla6"
          className="animable"
        />
        <path
          d="M392.298,390.543s1.378-1.806-.64-2.03c-2.018-.224-11.063,2.19-8.957,11.22,0,0,11.019-.828,11.491-4.579,.472-3.751-1.894-4.611-1.894-4.611Z"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "388.32px 394.116px",
          }}
          id="elk5yvcgmnxde"
          className="animable"
        />
        <polygon
          points="420.591 458.914 398.365 458.914 392.454 431.645 425.942 431.645 420.591 458.914"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "409.198px 445.279px",
          }}
          id="el2fum1hv0qwv"
          className="animable"
        />
        <rect
          x={390.437}
          y={431.251}
          width={37.434}
          height={7.842}
          style={{
            fill: "rgb(230, 230, 230)",
            transformOrigin: "409.154px 435.172px",
          }}
          id="elxksqtn0u1d"
          className="animable"
        />
      </g>
      <g
        id="el9bcfj5deni8"
        className="animable"
        style={{
          transformOrigin: "63.3448px 410.524px",
        }}
      >
        <g
          id="eluaszyhh3ouc"
          className="animable"
          style={{
            transformOrigin: "61.9895px 409.055px",
          }}
        >
          <path
            d="M61.195,438.748c-.013-.391-1.33-39.271-7.654-45.42-6.151-5.979-13.21-.222-13.507,.025l-.634-.76c.08-.068,8.047-6.571,14.831,.025,6.608,6.426,7.901,44.481,7.953,46.098l-.989,.031Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "50.792px 414.206px",
            }}
            id="ely7o08pripu8"
            className="animable"
          />
          <path
            d="M61.738,446.389c-.045-.465-4.322-46.675,12.554-66.042l.746,.649c-16.596,19.047-12.359,64.836-12.315,65.296l-.985,.097Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "68.1301px 413.368px",
            }}
            id="eligb6de2gpms"
            className="animable"
          />
          <path
            d="M61.114,441.501l-.988-.066c.035-.524,3.303-52.534-9.076-63.919l.67-.729c12.726,11.705,9.536,62.555,9.394,64.714Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "56.3103px 409.144px",
            }}
            id="el2ijlmlf4tm1"
            className="animable"
          />
          <path
            d="M62.725,441.472l-.99-.008c.012-1.432,.408-35.13,9.98-40.616,2.128-1.221,4.211-1.424,6.193-.604,5.788,2.394,8.656,12.695,8.776,13.132l-.955,.261c-.028-.103-2.86-10.271-8.2-12.479-1.683-.695-3.473-.511-5.322,.548-9.083,5.205-9.48,39.42-9.483,39.765Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "74.2095px 420.611px",
            }}
            id="el4xprwt4msjm"
            className="animable"
          />
          <path
            d="M58.998,441.496l-.988-.056c.015-.266,1.444-26.629-5.671-35.918-1.724-2.25-3.595-3.323-5.572-3.185-4.662,.326-8.571,7.148-8.61,7.217l-.862-.487c.169-.3,4.208-7.353,9.401-7.716,2.323-.165,4.489,1.038,6.429,3.571,7.338,9.58,5.936,35.478,5.873,36.576Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "48.2199px 421.417px",
            }}
            id="el6gp05s1bfqo"
            className="animable"
          />
          <path
            d="M60.558,445.082c-.194-2.558-4.651-62.755,3.192-73.362l.796,.588c-7.626,10.315-3.047,72.076-3.001,72.699l-.987,.075Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "61.8342px 408.401px",
            }}
            id="elp3lzkwsx6nc"
            className="animable"
          />
        </g>
        <path
          d="M80.042,406.345s-4.705,1.734-3.306,5.829c1.399,4.095,16.277,10.835,16.277,10.835,0,0,6.231-5.711,.509-14.999-5.722-9.288-13.352-4.595-13.479-1.664Z"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "86.2078px 412.769px",
          }}
          id="elvxusvgp4xih"
          className="animable"
        />
        <path
          d="M59.588,398.55s5.01-.21,5.295,4.108c.285,4.318-10.854,16.264-10.854,16.264,0,0-7.949-2.874-6.242-13.649,1.707-10.775,10.556-9.379,11.801-6.723Z"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "56.2176px 407.793px",
          }}
          id="el013xhgf6cs7n"
          className="animable"
        />
        <path
          d="M55.347,377.88s3.34-.359,3.072-2.393c-.269-2.035-12.985-7.271-20.488,1.196,0,0,4.804,8.252,11.748,8.36,6.945,.108,5.668-7.163,5.668-7.163Z"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "48.1827px 378.529px",
          }}
          id="elhdru12bnhlq"
          className="animable"
        />
        <path
          d="M61.571,372.939s-3.025,1.463-3.872-.406c-.848-1.869,7.175-13.039,18.021-9.82,0,0,.287,9.544-5.549,13.309-5.837,3.765-8.599-3.082-8.599-3.082Z"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "66.6799px 369.643px",
          }}
          id="elj7kla3ft4pb"
          className="animable"
        />
        <path
          d="M45.756,404.699s2.305-1.861-.183-2.77-14.695-.65-14.823,11.442c0,0,14.218,2.363,15.978-2.243,1.76-4.606-.972-6.429-.972-6.429Z"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "39.0345px 407.793px",
          }}
          id="el98551iiyowb"
          className="animable"
        />
        <path
          d="M74.749,377.577s-2.305-1.861,.183-2.77c2.488-.909,14.695-.65,14.822,11.442,0,0-14.218,2.363-15.978-2.243-1.76-4.606,.973-6.429,.973-6.429Z"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "81.4696px 380.671px",
          }}
          id="ela7mdv4e0crj"
          className="animable"
        />
        <path
          d="M67.233,387.318s-.203-2.263,1.624-1.376c1.827,.887,8.191,7.753,1.594,14.268,0,0-8.88-6.577-7.279-10.002,1.601-3.425,4.062-2.89,4.062-2.89Z"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "68.1778px 392.973px",
          }}
          id="elrw9q4rc9su9"
          className="animable"
        />
        <path
          d="M43.695,390.543s1.378-1.806-.64-2.03c-2.018-.224-11.063,2.19-8.957,11.22,0,0,11.019-.828,11.491-4.579,.472-3.751-1.895-4.611-1.895-4.611Z"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "39.7168px 394.116px",
          }}
          id="elnywtrrs66t"
          className="animable"
        />
        <polygon
          points="71.988 458.914 49.762 458.914 43.85 431.645 77.339 431.645 71.988 458.914"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "60.5945px 445.279px",
          }}
          id="elruiscij5tih"
          className="animable"
        />
        <rect
          x={41.834}
          y={431.251}
          width={37.434}
          height={7.842}
          style={{
            fill: "rgb(230, 230, 230)",
            transformOrigin: "60.551px 435.172px",
          }}
          id="elgoj4186au2n"
          className="animable"
        />
      </g>
      <path
        d="M362.241,119.758c-1.11-5.357-3.233-10.337-6.136-14.761l5.285-6.384-11.299-11.3-6.384,5.284c-4.423-2.902-9.404-5.025-14.76-6.136l-.775-8.229h-15.98l-.775,8.229c-5.356,1.111-10.337,3.234-14.76,6.136l-6.384-5.284-11.3,11.3,5.285,6.384c-2.903,4.423-5.025,9.403-6.136,14.76l-8.229,.776v15.979l8.229,.776c1.111,5.356,3.234,10.336,6.136,14.759l-5.285,6.384,11.3,11.3,6.384-5.286c4.423,2.904,9.403,5.026,14.76,6.137l.775,8.229h15.98l.775-8.228c5.356-1.11,10.337-3.234,14.76-6.137l6.384,5.286,11.299-11.3-5.285-6.383c2.903-4.424,5.026-9.404,6.136-14.76l8.228-.776v-15.979l-8.228-.776Zm-20.427,8.765c0,11.947-9.685,21.633-21.633,21.633s-21.633-9.686-21.633-21.633,9.685-21.633,21.633-21.633,21.633,9.685,21.633,21.633Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "320.181px 128.522px",
        }}
        id="eljkpocgcwlet"
        className="animable"
      />
      <path
        d="M133.451,231.766c-.958-4.622-2.79-8.919-5.295-12.736l4.56-5.508-9.749-9.75-5.509,4.56c-3.816-2.504-8.114-4.336-12.735-5.294l-.669-7.1h-13.788l-.669,7.1c-4.622,.958-8.919,2.79-12.735,5.294l-5.508-4.56-9.75,9.75,4.56,5.508c-2.505,3.816-4.336,8.113-5.295,12.735l-7.1,.669v13.787l7.1,.669c.959,4.622,2.79,8.918,5.295,12.735l-4.56,5.508,9.75,9.75,5.508-4.561c3.816,2.505,8.113,4.336,12.735,5.295l.669,7.1h13.788l.669-7.099c4.621-.958,8.919-2.79,12.735-5.296l5.509,4.561,9.749-9.75-4.56-5.508c2.505-3.817,4.336-8.114,5.295-12.735l7.099-.669v-13.787l-7.099-.669Zm-17.625,7.562c0,10.308-8.357,18.665-18.665,18.665s-18.665-8.357-18.665-18.665,8.357-18.665,18.665-18.665,18.665,8.357,18.665,18.665Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "97.1595px 239.327px",
        }}
        id="elq14oolpttn"
        className="animable"
      />
      <path
        d="M436.632,268.389c-.86-4.151-2.505-8.011-4.755-11.439l4.096-4.947-8.756-8.757-4.948,4.095c-3.428-2.249-7.287-3.894-11.438-4.755l-.601-6.377h-12.384l-.601,6.377c-4.151,.861-8.011,2.506-11.438,4.755l-4.947-4.095-8.757,8.757,4.096,4.948c-2.25,3.427-3.894,7.287-4.755,11.438l-6.377,.601v12.383l6.377,.601c.861,4.151,2.506,8.01,4.755,11.438l-4.096,4.947,8.757,8.757,4.947-4.096c3.427,2.25,7.287,3.895,11.438,4.756l.601,6.377h12.384l.601-6.376c4.151-.86,8.01-2.506,11.438-4.756l4.948,4.096,8.756-8.757-4.096-4.947c2.25-3.428,3.895-7.287,4.755-11.438l6.376-.601v-12.383l-6.376-.601Zm-15.83,6.792c0,9.258-7.506,16.764-16.764,16.764s-16.764-7.506-16.764-16.764,7.506-16.764,16.764-16.764,16.764,7.506,16.764,16.764Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "404.037px 275.181px",
        }}
        id="eluzz7n5i58de"
        className="animable"
      />
      <path
        d="M233.166,261.726c-.848-4.091-2.469-7.895-4.686-11.273l4.036-4.876-8.629-8.63-4.876,4.036c-3.378-2.216-7.182-3.838-11.272-4.686l-.592-6.284h-12.204l-.592,6.284c-4.091,.848-7.895,2.47-11.272,4.686l-4.876-4.036-8.63,8.63,4.036,4.876c-2.217,3.378-3.838,7.181-4.686,11.273l-6.284,.592v12.204l6.284,.592c.849,4.091,2.47,7.894,4.686,11.272l-4.036,4.876,8.63,8.63,4.876-4.037c3.378,2.218,7.182,3.838,11.272,4.687l.592,6.284h12.204l.592-6.284c4.091-.848,7.894-2.469,11.272-4.687l4.876,4.037,8.629-8.63-4.036-4.875c2.217-3.379,3.838-7.182,4.686-11.273l6.284-.592v-12.204l-6.284-.592Zm-15.6,6.694c0,9.124-7.397,16.521-16.522,16.521s-16.521-7.397-16.521-16.521,7.397-16.522,16.521-16.522,16.522,7.397,16.522,16.522Z"
        style={{
          fill: "rgb(240, 240, 240)",
          transformOrigin: "201.044px 268.42px",
        }}
        id="elq7l81nh59xc"
        className="animable"
      />
      <path
        d="M217.108,197.942c-.398-1.922-1.16-3.71-2.202-5.297l1.897-2.291-4.055-4.055-2.291,1.896c-1.587-1.041-3.375-1.803-5.297-2.202l-.278-2.953h-5.734l-.278,2.953c-1.922,.399-3.709,1.16-5.297,2.202l-2.291-1.896-4.055,4.055,1.897,2.291c-1.042,1.587-1.803,3.374-2.202,5.297l-2.953,.278v5.734l2.953,.278c.399,1.922,1.16,3.709,2.202,5.296l-1.897,2.291,4.055,4.055,2.291-1.897c1.587,1.042,3.374,1.804,5.297,2.202l.278,2.953h5.734l.278-2.953c1.922-.398,3.709-1.16,5.297-2.202l2.291,1.897,4.055-4.055-1.897-2.291c1.042-1.588,1.804-3.374,2.202-5.297l2.953-.278v-5.734l-2.953-.278Zm-7.33,3.145c0,4.287-3.476,7.763-7.763,7.763s-7.763-3.476-7.763-7.763,3.476-7.763,7.763-7.763,7.763,3.476,7.763,7.763Z"
        style={{
          fill: "rgb(240, 240, 240)",
          transformOrigin: "202.015px 201.086px",
        }}
        id="el8fustotc5zv"
        className="animable"
      />
      <path
        d="M281.328,61.484c-.451-2.176-1.313-4.199-2.492-5.995l2.147-2.593-4.589-4.59-2.593,2.146c-1.797-1.179-3.819-2.041-5.995-2.492l-.315-3.342h-6.49l-.315,3.342c-2.175,.451-4.198,1.314-5.995,2.492l-2.593-2.146-4.59,4.59,2.147,2.593c-1.179,1.796-2.041,3.819-2.492,5.995l-3.342,.315v6.49l3.342,.315c.451,2.176,1.313,4.198,2.492,5.995l-2.147,2.593,4.59,4.59,2.593-2.147c1.796,1.179,3.819,2.041,5.995,2.493l.315,3.342h6.49l.315-3.342c2.175-.451,4.198-1.313,5.995-2.493l2.593,2.147,4.589-4.59-2.147-2.593c1.179-1.797,2.041-3.819,2.492-5.995l3.342-.315v-6.49l-3.342-.315Zm-8.297,3.56c0,4.852-3.934,8.786-8.786,8.786s-8.786-3.934-8.786-8.786,3.934-8.787,8.786-8.787,8.786,3.934,8.786,8.787Z"
        style={{
          fill: "rgb(240, 240, 240)",
          transformOrigin: "264.246px 65.044px",
        }}
        id="elz4db9jehdp8"
        className="animable"
      />
      <path
        d="M410.854,107.395c-.343-1.655-.999-3.193-1.895-4.559l1.633-1.972-3.49-3.49-1.972,1.632c-1.366-.896-2.905-1.552-4.559-1.895l-.239-2.542h-4.936l-.24,2.542c-1.655,.343-3.193,.999-4.559,1.895l-1.972-1.632-3.49,3.49,1.632,1.972c-.897,1.366-1.552,2.905-1.896,4.559l-2.542,.24v4.936l2.542,.24c.343,1.655,.999,3.193,1.896,4.559l-1.632,1.972,3.49,3.491,1.972-1.633c1.366,.897,2.905,1.553,4.559,1.896l.24,2.542h4.936l.239-2.542c1.654-.343,3.193-.999,4.559-1.896l1.972,1.633,3.49-3.491-1.633-1.972c.897-1.367,1.552-2.905,1.895-4.559l2.542-.24v-4.936l-2.542-.24Zm-6.31,2.708c0,3.69-2.992,6.682-6.682,6.682s-6.682-2.992-6.682-6.682,2.992-6.682,6.682-6.682,6.682,2.992,6.682,6.682Z"
        style={{
          fill: "rgb(240, 240, 240)",
          transformOrigin: "397.863px 110.103px",
        }}
        id="elinws02cild"
        className="animable"
      />
    </g>
    <g
      id="freepik--Shadow_2--inject-120"
      className="animable"
      style={{
        transformOrigin: "255.775px 460.364px",
      }}
    >
      <path
        d="M464.65,460.364c0,3.387-93.516,6.132-208.875,6.132s-208.875-2.745-208.875-6.132,93.516-6.132,208.875-6.132,208.875,2.745,208.875,6.132Z"
        style={{
          fill: "rgb(245, 245, 245)",
          transformOrigin: "255.775px 460.364px",
        }}
        id="elrb9ben48wsh"
        className="animable"
      />
    </g>
    <g
      id="freepik--Speech_Bubble--inject-120"
      className="animable"
      style={{
        transformOrigin: "391.507px 173.128px",
      }}
    >
      <g
        id="el1j2nyo04x77"
        className="animable"
        style={{
          transformOrigin: "391.507px 173.128px",
        }}
      >
        <path
          d="M408.344,151.93h-33.676c-3.449,0-6.244,2.796-6.244,6.245v24.392c0,3.449,2.796,6.245,6.244,6.245h4.233v7.591l6.168-7.591h23.275c3.449,0,6.245-2.796,6.245-6.245v-24.392c0-3.449-2.796-6.245-6.245-6.245Z"
          style={{
            fill: "#213E60",
            transformOrigin: "391.507px 174.166px",
          }}
          id="ele083dg3mxli"
          className="animable"
        />
        <path
          d="M383.154,166.856c1.949-.298,3.604,1.357,3.306,3.306-.186,1.215-1.179,2.208-2.394,2.394-1.95,.299-3.605-1.357-3.306-3.307,.186-1.215,1.18-2.208,2.394-2.393Zm6.377,2.393c-.299,1.95,1.356,3.606,3.306,3.307,1.215-.186,2.208-1.179,2.394-2.394,.298-1.949-1.356-3.604-3.306-3.306-1.215,.186-2.208,1.178-2.394,2.393Zm8.772,0c-.299,1.95,1.356,3.606,3.306,3.307,1.215-.186,2.208-1.179,2.394-2.394,.298-1.949-1.356-3.604-3.306-3.306-1.215,.186-2.208,1.178-2.394,2.393Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "392.381px 169.706px",
          }}
          id="eljut6u5l3yja"
          className="animable"
        />
        <path
          d="M375.171,150.603h21.975c.483,0,.483-.75,0-.75h-21.975c-.483,0-.483,.75,0,.75h0Z"
          style={{
            fill: "#213E60",
            transformOrigin: "386.158px 150.228px",
          }}
          id="eljhp8z3pq9n9"
          className="animable"
        />
      </g>
    </g>
    <g
      id="freepik--Character_2--inject-120"
      className="animable"
      style={{
        transformOrigin: "337.197px 328.803px",
      }}
    >
      <g
        id="elebg9bs3aq7i"
        className="animable"
        style={{
          transformOrigin: "337.197px 328.803px",
        }}
      >
        <g
          id="el9lbmi2yusqo"
          className="animable"
          style={{
            transformOrigin: "316.26px 262.839px",
          }}
        >
          <path
            d="M303.66,271.106c.178-.03,7.506,3.674,7.506,3.674l3.516-8.533-5.917,.044s-5.401,4.697-5.253,4.756"
            style={{
              fill: "rgb(185, 121, 100)",
              transformOrigin: "309.096px 270.514px",
            }}
            id="elyte7387ahuj"
            className="animable"
          />
          <g
            id="el9lo3vck4fi"
            className="animable"
            style={{
              transformOrigin: "299.45px 264.65px",
            }}
          >
            <path
              d="M309.068,266.39s-.112-2.736-1.795-4.25c-1.683-1.514-2.624-3.172-3.953-4.211-1.329-1.039-.889,1.195-.414,2.336,.475,1.141,1.001,2.439,.087,2.657-.915,.218-8.673-2.069-9.907-1.623-1.234,.447-.095,1.209-.095,1.209,0,0-1.743-.5-2.304,.193-.561,.693,.44,1.336,.44,1.336,0,0-1.182-.295-1.294,.563-.112,.857,5.836,3.684,6.037,3.957,0,0-2.994-2.29-3.84-1.563-.846,.727,1.238,2.042,2.878,3.126,1.64,1.084,3.719,1.707,5.713,1.469,1.993-.238,5.462,.41,6.688-1.559,1.225-1.97,1.76-3.64,1.76-3.64Z"
              style={{
                fill: "rgb(185, 121, 100)",
                transformOrigin: "299.45px 264.65px",
              }}
              id="elfxpy6ufw81w"
              className="animable"
            />
            <g id="el91ekjmbzpjj">
              <g
                style={{
                  opacity: 0.2,
                  transformOrigin: "295.217px 265.261px",
                }}
                className="animable"
                id="elzt5xypdb889"
              >
                <path
                  d="M291.326,264.288c1.988,.584,3.955,1.233,5.882,1.949-.174,.513-.302,1.031-.402,1.565-.041,.266,.373,.231,.424-.027,.29-1.61,.956-3.161,1.959-4.587,.162-.231-.179-.402-.341-.171-.251,.356-.474,.711-.679,1.081-.012-.035-.041-.06-.079-.075-1.461-.674-3.007-1.168-4.637-1.484-.248-.042-.396,.351-.138,.401,1.594,.309,3.111,.788,4.535,1.447,.056,.022-.209,.605-.156,.582-.259,.475-.161,.378-.346,.874-1.927-.716-3.884-1.366-5.882-1.949-.241-.07-.38,.322-.139,.392Z"
                  id="elt1vhzga9nxr"
                  className="animable"
                  style={{
                    transformOrigin: "295.217px 265.261px",
                  }}
                />
              </g>
            </g>
            <g id="elcq8x76w22me">
              <g
                style={{
                  opacity: 0.2,
                  transformOrigin: "302.548px 266.578px",
                }}
                className="animable"
                id="elw4cqi0673b8"
              >
                <path
                  d="M299.656,265.695c2.4-.547,4.558,.331,5.616,2.234,.118,.217,.498-.006,.38-.222-1.144-2.069-3.477-2.977-6.064-2.396-.266,.068-.189,.442,.069,.384Z"
                  id="eldaipf9hg85u"
                  className="animable"
                  style={{
                    transformOrigin: "302.548px 266.578px",
                  }}
                />
              </g>
            </g>
          </g>
          <path
            d="M342.689,241.431c-.425,0-.848,.093-1.22,.298-3.48,1.918-5.088,5.077-6.198,8.919-2.378,8.232-4.771,18.322-4.771,18.322,0,0-16.401-3.77-20.171-4.321l-3.128,8.743s21.654,10.113,23.777,10.679c6.277,1.674,9.509-9.185,9.509-9.185l2.202-33.456h0Z"
            style={{
              fill: "#213E60",
              transformOrigin: "324.945px 262.838px",
            }}
            id="elvlcqvq9y9pg"
            className="animable"
          />
          <g id="elwuizswcsgsd">
            <path
              d="M335.484,283.075l-1.994-17.813v18.985s1.281-.658,1.994-1.172Z"
              style={{
                opacity: 0.3,
                transformOrigin: "334.487px 274.755px",
              }}
              className="animable"
              id="elasqhhr8ulo4"
            />
          </g>
        </g>
        <g
          id="elp92tdd6w6xn"
          className="animable"
          style={{
            transformOrigin: "355.839px 224.622px",
          }}
        >
          <path
            d="M376.115,234.253c.774-7.214-4.483-5.439-3.795-14.663,.757-10.156-8.898-12.698-8.898-12.698,0,0-3.337-4.461-7.967-5.71-5.931-1.601-21.074,2.306-17.597,15.142,2.073,7.653,.804,7.34-.345,10.539-1.626,4.528,2.287,10.742-2.028,13.488,0,0,16.569-.34,34.284,.684,0,0,5.874-2.377,6.347-6.782Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "355.839px 220.939px",
            }}
            id="elw603muf9tt"
            className="animable"
          />
          <path
            d="M362.874,240.698s-2.956,1.454-6.6,4.594c-.759,.654-1.595,1.22-2.48,1.69-2.388,1.268-4.565,1.994-5.154,.843-.131-.253-.232-.527-.306-.815-.501-1.928-.295-4.638,1.263-5.879,1.757-1.399,2.604-2.595,2.288-4.489-.166-1.073-.555-2.181-1.009-3.257l2.029-1.218,7.232-7.298c-.827,4.475-1.071,13.184,2.738,15.829Z"
            style={{
              fill: "rgb(185, 121, 100)",
              transformOrigin: "355.483px 236.635px",
            }}
            id="elkdwawxeprco"
            className="animable"
          />
          <g id="elzwmfz13in1e">
            <path
              d="M351.942,237.059c1.989-1.181,4.171-3.229,3.91-5.568-.117-.985-.329-1.919-.565-2.517l-4.04,5.349c.332,.862,.453,1.432,.695,2.737Z"
              style={{
                opacity: 0.2,
                transformOrigin: "353.56px 233.017px",
              }}
              className="animable"
              id="el5oewp5a3hai"
            />
          </g>
          <path
            d="M361.537,216.641c-.681,7.431-.812,10.582-4.646,14.478-5.768,5.861-14.641,3.889-16.169-3.476-1.375-6.629-.031-17.667,7.264-20.79,7.187-3.077,14.232,2.357,13.551,9.788Z"
            style={{
              fill: "rgb(185, 121, 100)",
              transformOrigin: "350.913px 220.262px",
            }}
            id="elrqnwwqnhq4"
            className="animable"
          />
          <path
            d="M353.463,216.321c-.095,.011-.191-.017-.264-.085-1.145-1.06-2.434-.688-2.449-.684-.191,.056-.384-.052-.428-.247-.043-.195,.078-.399,.271-.458,.067-.02,1.685-.489,3.105,.827,.142,.131,.144,.363,.007,.518-.067,.074-.154,.118-.243,.128Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "352.06px 215.536px",
            }}
            id="ell2uzsaqnwv"
            className="animable"
          />
          <path
            d="M342.12,215.309c-.075-.025-.137-.081-.17-.162-.068-.168,.015-.382,.184-.477,1.698-.955,2.957-.229,3.01-.197,.149,.089,.186,.3,.08,.471-.105,.172-.311,.238-.46,.151-.049-.029-1.035-.576-2.385,.184-.087,.049-.181,.057-.26,.03Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "343.605px 214.752px",
            }}
            id="elpivd4agsy1"
            className="animable"
          />
          <path
            d="M346.578,218.675s-1.163,2.781-2.474,4.515c-.229,.303-.087,.745,.269,.877,.918,.338,1.991,.032,1.991,.032l.213-5.424Z"
            style={{
              fill: "rgb(162, 78, 63)",
              transformOrigin: "345.285px 221.451px",
            }}
            id="elzya09a09qd"
            className="animable"
          />
          <g
            id="elrchvrualtzl"
            className="animable"
            style={{
              transformOrigin: "349.58px 219.117px",
            }}
          >
            <path
              d="M350.735,219.283c-.036,.786-.462,1.432-.951,1.442-.488,.01-.855-.619-.818-1.405,.036-.786,.462-1.432,.951-1.442,.488-.01,.855,.619,.818,1.405Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "349.85px 219.302px",
              }}
              id="elb8uko2uyo8u"
              className="animable"
            />
            <path
              d="M350.128,217.911l-1.705-.403s.933,1.272,1.705,.403Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "349.275px 217.861px",
              }}
              id="ele0pmc5fdjcj"
              className="animable"
            />
          </g>
          <g
            id="elgvmt9em346s"
            className="animable"
            style={{
              transformOrigin: "342.643px 219.08px",
            }}
          >
            <path
              d="M343.814,219.254c-.037,.762-.462,1.388-.949,1.398-.487,.01-.852-.599-.815-1.361,.037-.762,.462-1.387,.949-1.398s.852,.599,.815,1.361Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "342.932px 219.272px",
              }}
              id="eltkkm2nmk12l"
              className="animable"
            />
            <path
              d="M343.175,217.911l-1.705-.403s.932,1.272,1.705,.403Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "342.322px 217.861px",
              }}
              id="elrleak9laom"
              className="animable"
            />
          </g>
          <path
            d="M358.958,219.207s-3.833-5.77-3.635-10.442c0,0-7.337-1.913-13.188,5.904-.932,1.245-1.488,3.322-2.322,5.112,0,0-1.401-14.138,11.145-15.297,12.526-1.157,14.988,16.453,8.877,22.378,0,0,1.497-4.045-.876-7.655Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "351.402px 215.646px",
            }}
            id="el51q59y5d5fx"
            className="animable"
          />
          <g
            id="elho1bmt8vw1a"
            className="animable"
            style={{
              transformOrigin: "360.963px 221.894px",
            }}
          >
            <path
              d="M363.785,222.697c-.878,1.524-2.304,2.481-3.611,2.809-1.967,.493-2.982-2.669-2.311-4.64,.604-1.774,2.537-2.948,4.451-2.561,1.886,.381,2.475,2.649,1.471,4.392Z"
              style={{
                fill: "rgb(185, 121, 100)",
                transformOrigin: "360.963px 221.894px",
              }}
              id="eliqfd77o27qf"
              className="animable"
            />
            <g id="el3bmmg8q3r1b">
              <path
                d="M359.629,222.55h-.017c-.138-.01-.242-.129-.232-.267,.051-.772,.414-1.509,.996-2.02,.583-.511,1.377-.772,2.133-.727,.138,.009,.242,.127,.233,.266-.008,.137-.132,.251-.265,.233-.641-.043-1.288,.179-1.771,.604-.483,.424-.785,1.036-.828,1.677-.009,.132-.118,.233-.249,.233Z"
                style={{
                  opacity: 0.2,
                  transformOrigin: "361.061px 221.041px",
                }}
                className="animable"
                id="eli4cixmg2ng"
              />
            </g>
          </g>
          <g
            id="elyknm89r9cfr"
            className="animable"
            style={{
              transformOrigin: "349.365px 226.216px",
            }}
          >
            <path
              d="M347.661,225.705c.692-.307,2.03-1.206,2.99-1.452,.559-.143,1.082,.367,1.091,.945h0c0,.066-.002,.131-.014,.196-.161,.877-.844,1.864-2.768,2.637-.145,.063-.294,.119-.442,.174,0,0-.878-1.481-1.533-2.215,0,0,.267-.097,.676-.284Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "349.364px 226.217px",
              }}
              id="eltemgnshj9x"
              className="animable"
            />
            <path
              d="M346.996,225.973l.469,.641c1.878-.76,3.098-1.547,3.458-2.353-.242-.26-2.482,1.035-2.482,1.035-.325,.199-.461,.241-1.444,.676Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "348.96px 225.42px",
              }}
              id="el6cu0i0oe9fk"
              className="animable"
            />
            <path
              d="M348.96,228.03c1.996-.802,2.657-1.833,2.784-2.733-.67,.299-1.444,.735-2.04,1.329-.458,.453-.66,.95-.745,1.404Z"
              style={{
                fill: "rgb(253, 80, 78)",
                transformOrigin: "350.351px 226.663px",
              }}
              id="ely1kwodt4j9h"
              className="animable"
            />
          </g>
        </g>
        <g
          id="elodb7hafxvao"
          className="animable"
          style={{
            transformOrigin: "355.527px 263.093px",
          }}
        >
          <path
            d="M367.849,289.791c.673-7.636,3.384-21.629,8.053-36.325,1.519-4.779-3.548-10.567-3.548-10.567,0,0-3.863,.228-4.505,.156-.703-.082-1.427-.154-2.151-.216-5.454-.452-9.919-.781-14.781-.503-1.223,.072-2.477,.175-3.711,.278-.398,.041-2.978,.08-3.366,.121,0,0-6.992,8.181-7.369,13.957-.204,3.227-1.763,4.616-1.59,12.334,.031,5.241,3.835,12.877,4.181,20.246l28.787,.52Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "355.527px 266.013px",
            }}
            id="eleg6utlilthp"
            className="animable"
          />
          <path
            d="M348.142,242.916l3.61-4.96,1.719,2.952,6.686-4.513,1.326,1.99-2.531,7.427s-6.327,2.59-6.662,2.59-4.147-5.486-4.147-5.486Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "354.812px 242.398px",
            }}
            id="el7b4xffp76v4"
            className="animable"
          />
          <g id="el7e8wggx2q0w">
            <polygon
              points="347.975 243.148 349.453 246.802 353.126 243.148 355.625 247.439 359.358 245.61 355.379 248.761 353.077 244.06 348.865 248.026 347.975 243.148"
              style={{
                opacity: 0.3,
                transformOrigin: "353.667px 245.954px",
              }}
              className="animable"
              id="el9r85zfct1h9"
            />
          </g>
        </g>
        <g
          id="elydx5p0mggb"
          className="animable"
          style={{
            transformOrigin: "369.656px 446.413px",
          }}
        >
          <path
            d="M375.76,441.767l-.817,1.138-1.621-.699-1.011,4.998-6.839,9.552s-2.602,.417-.552-5.011c.093-.247,.168-.519,.217-.822,.609-3.247-.731-9.471-.731-9.471l3.752-5.241s.391,.006,1.057,.116c1.554,.26,4.663,1.018,6.545,5.44Z"
            style={{
              fill: "#213E60",
              transformOrigin: "369.947px 446.487px",
            }}
            id="el71g426io9xe"
            className="animable"
          />
          <g id="elt06iwziz26o">
            <path
              d="M375.76,441.767l-.817,1.138-1.621-.699-1.011,4.998-6.839,9.552s-2.602,.417-.552-5.011c.093-.247,.168-.519,.217-.822,.609-3.247-.731-9.471-.731-9.471l3.752-5.241s.391,.006,1.057,.116c1.554,.26,4.663,1.018,6.545,5.44Z"
              style={{
                opacity: 0.2,
                transformOrigin: "369.947px 446.487px",
              }}
              className="animable"
              id="el66qmrri9cag"
            />
          </g>
          <path
            d="M369.216,436.327l.016,.011c-1.261,.135-.155,5.73-.662,8.869-.457,2.801-1.664,5.442-3.432,5.716,.609-3.247-1.587-10.646-1.587-10.646l3.018-4.215s1.982,.155,2.648,.264Z"
            style={{
              fill: "rgb(162, 78, 63)",
              transformOrigin: "366.391px 443.492px",
            }}
            id="elv85w1r5d8ha"
            className="animable"
          />
        </g>
        <g
          id="elbnl8ktx09se"
          className="animable"
          style={{
            transformOrigin: "358.772px 450.925px",
          }}
        >
          <path
            d="M367.227,456.328l-1.394-.002-.387-1.734-4.612,2.099h-11.686s-1.858-1.883,3.707-3.384c.253-.069,.516-.167,.788-.304,2.967-1.403,7.19-6.14,7.19-6.14h6.412s.224,.324,.525,.932c.7,1.422,1.91,4.407-.545,8.534Z"
            style={{
              fill: "#213E60",
              transformOrigin: "358.772px 451.777px",
            }}
            id="elq9k56yvk66"
            className="animable"
          />
          <path
            d="M367.772,447.794v.02c-.847-.951-4.7,3.227-7.521,4.65-2.52,1.265-5.351,1.824-6.606,.54,2.967-1.403,7.68-7.845,7.68-7.845l5.152,.157s.995,1.871,1.296,2.479Z"
            style={{
              fill: "rgb(185, 121, 100)",
              transformOrigin: "360.709px 449.446px",
            }}
            id="eldmaddi30r7"
            className="animable"
          />
        </g>
        <g
          id="elaqz1rn2mdzj"
          className="animable"
          style={{
            transformOrigin: "344.905px 364.677px",
          }}
        >
          <path
            d="M354.67,391.398c-3.181-8.766-7.075-17.389-11.754-24.367,19.124-54.86,18.526-79.403,18.526-79.403l-23.03-.019-2.454,9.174s-5.754,22.84-7.432,35.951l-4.806,29.149v.082c-.326,6.053,1.009,12.066,3.874,17.389,3.129,5.817,8.665,12.722,11.703,18.991,3.996,8.273,7.768,16.567,10.989,23.987,3.395,7.821,6.157,14.655,7.88,19.403,1.631,.185,6.555-2.775,7.972-5.457,0,0-3.486-22.877-11.468-44.88Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "344.905px 364.676px",
            }}
            id="el21bllra9xqs"
            className="animable"
          />
          <g id="el5plrmdd5u3">
            <path
              d="M348.239,350.712c2.805-9.324,5.947-14.638,7.374-21.564,.012-1.617-5.36-8.536-8.095-11.324,0,0-3.291,13.225,.721,32.888Z"
              style={{
                opacity: 0.2,
                transformOrigin: "350.93px 334.268px",
              }}
              className="animable"
              id="el0m98m7b9mcea"
            />
          </g>
          <g id="elcshvf1bk2ed">
            <path
              d="M350.286,422.333c3.395,7.821,6.157,14.655,7.88,19.403,1.631,.185,6.555-2.775,7.972-5.457,0,0-3.486-22.877-11.468-44.88-1.621,9.085-3.436,20.564-4.384,30.934Z"
              style={{
                opacity: 0.2,
                transformOrigin: "358.212px 416.572px",
              }}
              className="animable"
              id="el5lj3l7wkroc"
            />
          </g>
        </g>
        <path
          d="M344.227,288.129s8.765,60.598,9.785,74.242c0,0,5.415,66.182,4.444,82.817l12.077,.587s8.123-50.126,4.016-82.294c-.356-4.193,3.384-31.543,3.976-42.439,1.423-26.212-9.213-33.414-9.213-33.414l-25.084,.501Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "361.442px 366.701px",
          }}
          id="elka9f7ym0wbe"
          className="animable"
        />
        <g id="elaeui84h7eco">
          <polygon
            points="359.522 289.038 361.442 319.138 378.656 317.086 378.656 313.992 359.522 289.038"
            style={{
              opacity: 0.2,
              transformOrigin: "369.089px 304.088px",
            }}
            className="animable"
            id="elij5qxj9qit9"
          />
        </g>
        <g
          id="elo34lsl9059"
          className="animable"
          style={{
            transformOrigin: "371.347px 277.539px",
          }}
        >
          <path
            d="M372.794,281.443l5.12-24.796c1.142-4.563-.584-3.697-.522-4.93,.204-3.854-4.47-9.966-4.47-9.966l-11.856-1.46s-2.268,8.189-2.747,23.841c-.479,15.642,4.094,52.561,4.094,52.561l22.15-2.315-11.768-32.934Z"
            style={{
              fill: "#213E60",
              transformOrigin: "371.423px 278.492px",
            }}
            id="el49p1nsampdb"
            className="animable"
          />
          <g
            id="elm36kz0ii2v"
            className="animable"
            style={{
              transformOrigin: "362.585px 254.383px",
            }}
          >
            <path
              d="M361.372,238.567s-4.584,9.047-2.85,31.814l7.616-16.366-2.757-4.472,3.658-7.31s-3.913-2.517-5.557-3.848l-.11,.182Z"
              style={{
                fill: "#213E60",
                transformOrigin: "362.585px 254.383px",
              }}
              id="elcr78zxeroy"
              className="animable"
            />
            <g id="elo3l426qhc1b">
              <g
                style={{
                  opacity: 0.2,
                  transformOrigin: "362.585px 254.383px",
                }}
                className="animable"
                id="elzb2v1pat7e"
              >
                <path
                  d="M361.372,238.567s-4.584,9.047-2.85,31.814l7.616-16.366-2.757-4.472,3.658-7.31s-3.913-2.517-5.557-3.848l-.11,.182Z"
                  id="elne2iy2c4m9"
                  className="animable"
                  style={{
                    transformOrigin: "362.585px 254.383px",
                  }}
                />
              </g>
            </g>
          </g>
        </g>
        <g
          id="elmm83pmga6kd"
          className="animable"
          style={{
            transformOrigin: "339.964px 277.733px",
          }}
        >
          <path
            d="M350.706,239.384s-10.191,12.297-12.694,21.17c-1.646,5.834,1.6,22.645,1.221,27.093-.624,7.329-3.861,16.3-8.059,29.439l-2.776-.394,7.646-29.083s-3.538-21.915-2.597-27.399c.941-5.484,9.113-18.78,9.113-18.78l3.73-.257,4.415-1.79Z"
            style={{
              fill: "#213E60",
              transformOrigin: "339.552px 278.234px",
            }}
            id="elxp2zkvorukh"
            className="animable"
          />
          <g
            id="elq7robpdfkse"
            className="animable"
            style={{
              transformOrigin: "344px 254.447px",
            }}
          >
            <path
              d="M337.903,270.514s-1.706-5.021-1.394-9.654c.312-4.633,.384-8.09,.384-8.09l5.257-3.885-.692-4.737s2.535-1.557,4.89-3.151c1.609-1.09,4.766-2.738,5.181-2.611,0,0-13.426,16.99-13.494,23.942-.065,6.705-.133,8.187-.133,8.187Z"
              style={{
                fill: "#213E60",
                transformOrigin: "344px 254.447px",
              }}
              id="elf7kxuzpmhul"
              className="animable"
            />
            <g id="elfqdftueabb">
              <path
                d="M337.903,270.514s-1.706-5.021-1.394-9.654c.312-4.633,.384-8.09,.384-8.09l5.257-3.885-.692-4.737s2.535-1.557,4.89-3.151c1.609-1.09,4.766-2.738,5.181-2.611,0,0-13.426,16.99-13.494,23.942-.065,6.705-.133,8.187-.133,8.187Z"
                style={{
                  opacity: 0.3,
                  transformOrigin: "344px 254.447px",
                }}
                className="animable"
                id="elz56ouxa8sd"
              />
            </g>
          </g>
        </g>
        <g id="elwmjefvoa17s">
          <path
            d="M324.945,274.469s25.162,10.548,32.295,9.524c7.134-1.023,18.739-25.42,18.739-25.42l-22.633,20.972-29.065-5.273"
            style={{
              opacity: 0.3,
              transformOrigin: "350.13px 271.318px",
            }}
            className="animable"
            id="ellv3ynsr3pw"
          />
        </g>
        <g
          id="elyf80p3eab4m"
          className="animable"
          style={{
            transformOrigin: "346.578px 262.034px",
          }}
        >
          <path
            d="M320.181,263.33s-4.862-15.85-5.927-15.056c-1.065,.794,0,17.403,0,17.403,.331,.627,.753,1.626,2.339,2.119,1.517,.471,8.844,2.426,8.844,2.426l1.144-6.285-6.4-.607Z"
            style={{
              fill: "rgb(185, 121, 100)",
              transformOrigin: "320.181px 259.234px",
            }}
            id="elq20w9lxrj9k"
            className="animable"
          />
          <path
            d="M372.921,241.75s9.018,1.398,5.735,12.633c-1.956,6.692-18.953,27.763-23.129,27.932s-35.347-9.267-35.347-9.267l2.359-11.014,26.948,5.953,17.151-23.364,6.284-2.872Z"
            style={{
              fill: "#213E60",
              transformOrigin: "349.778px 262.034px",
            }}
            id="elhrpawuf3ofb"
            className="animable"
          />
        </g>
      </g>
    </g>
    <g
      id="freepik--Blocks--inject-120"
      className="animable"
      style={{
        transformOrigin: "271.851px 304.406px",
      }}
    >
      <g
        id="elrlt09ynbcj"
        className="animable"
        style={{
          transformOrigin: "275.889px 189.673px",
        }}
      >
        <polygon
          points="248.532 151.31 245.949 151.31 229.103 151.31 229.103 228.036 245.949 228.036 248.532 228.036 322.675 228.036 322.675 151.31 248.532 151.31"
          style={{
            fill: "#213E60",
            transformOrigin: "275.889px 189.673px",
          }}
          id="el6yax6n2783o"
          className="animable"
        />
        <g id="el5bunqy37g9r">
          <rect
            x={229.103}
            y={151.31}
            width={93.572}
            height={76.726}
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.3,
              transformOrigin: "275.889px 189.673px",
            }}
            className="animable"
            id="elopelfgmvrtm"
          />
        </g>
        <g id="elaiw3ldkvz4v">
          <rect
            x={229.103}
            y={151.31}
            width={16.253}
            height={76.726}
            style={{
              opacity: 0.3,
              transformOrigin: "237.23px 189.673px",
            }}
            className="animable"
            id="el2pt8lt1rabc"
          />
        </g>
        <path
          d="M295.599,207.669l-8.241-11.735c-.765,.055-1.583,.109-2.401,.109h-9.442v11.625h-5.458v-38.206h14.9c9.933,0,15.937,5.021,15.937,13.318,0,5.894-3.057,10.152-8.405,12.062l9.06,12.827h-5.949Zm-.163-24.889c0-5.458-3.657-8.569-10.643-8.569h-9.278v17.193h9.278c6.986,0,10.643-3.166,10.643-8.623Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "285.803px 188.566px",
          }}
          id="elff7ukvpfbvm"
          className="animable"
        />
      </g>
      <g
        id="el946e6r0xvf"
        className="animable"
        style={{
          transformOrigin: "267.396px 266.399px",
        }}
      >
        <polygon
          points="240.039 228.036 237.456 228.036 220.61 228.036 220.61 304.762 237.456 304.762 240.039 304.762 314.182 304.762 314.182 228.036 240.039 228.036"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "267.396px 266.399px",
          }}
          id="elazv9j2k8pgp"
          className="animable"
        />
        <g id="el0wp1zz5wjku">
          <rect
            x={220.61}
            y={228.036}
            width={93.572}
            height={76.726}
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.3,
              transformOrigin: "267.396px 266.399px",
            }}
            className="animable"
            id="el7zlxpk6xz8l"
          />
        </g>
        <g id="elk0msq3h6h1">
          <rect
            x={220.61}
            y={228.036}
            width={16.253}
            height={76.726}
            style={{
              opacity: 0.3,
              transformOrigin: "228.737px 266.399px",
            }}
            className="animable"
            id="elatdi1hluobd"
          />
        </g>
        <path
          d="M285.904,274.844h-20.304l-4.203,9.552h-5.622l17.302-38.207h5.404l17.356,38.207h-5.731l-4.202-9.552Zm-1.91-4.366l-8.242-18.722-8.241,18.722h16.483Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "275.806px 265.292px",
          }}
          id="elsjn0dqinx4e"
          className="animable"
        />
      </g>
      <g
        id="el0bibof8fwcqk"
        className="animable"
        style={{
          transformOrigin: "269.217px 342.414px",
        }}
      >
        <polygon
          points="241.86 304.051 239.277 304.051 222.431 304.051 222.431 380.777 239.277 380.777 241.86 380.777 316.003 380.777 316.003 304.051 241.86 304.051"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "269.217px 342.414px",
          }}
          id="elthjiwmgqtc"
          className="animable"
        />
        <g id="elyysynwqhfl">
          <rect
            x={222.431}
            y={304.051}
            width={16.253}
            height={76.726}
            style={{
              opacity: 0.3,
              transformOrigin: "230.558px 342.414px",
            }}
            className="animable"
            id="el8b3to9fjx8x"
          />
        </g>
        <path
          d="M296.24,322.204v38.206h-4.476l-22.924-28.491v28.491h-5.458v-38.206h4.476l22.924,28.49v-28.49h5.458Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "279.811px 341.307px",
          }}
          id="ellgnjck07c9"
          className="animable"
        />
      </g>
      <g
        id="elx90j7xc9hfn"
        className="animable"
        style={{
          transformOrigin: "276.306px 419.14px",
        }}
      >
        <polygon
          points="248.949 380.777 246.366 380.777 229.52 380.777 229.52 457.503 246.366 457.503 248.949 457.503 323.092 457.503 323.092 380.777 248.949 380.777"
          style={{
            fill: "#213E60",
            transformOrigin: "276.306px 419.14px",
          }}
          id="el0i4aku4bzp86"
          className="animable"
        />
        <g id="el8wt53ktr5zf">
          <rect
            x={229.52}
            y={380.777}
            width={16.253}
            height={76.726}
            style={{
              opacity: 0.3,
              transformOrigin: "237.647px 419.14px",
            }}
            className="animable"
            id="elvm5wlrualoh"
          />
        </g>
        <path
          d="M270.473,398.93h16.1c12.281,0,20.632,7.75,20.632,19.102s-8.351,19.104-20.632,19.104h-16.1v-38.206Zm15.773,33.458c9.442,0,15.501-5.786,15.501-14.355s-6.059-14.354-15.501-14.354h-10.315v28.71h10.315Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "288.839px 418.033px",
          }}
          id="el6p6troisi4e"
          className="animable"
        />
      </g>
    </g>
    <g
      id="freepik--Shadow_1--inject-120"
      className="animable"
      style={{
        transformOrigin: "242.155px 163.683px",
      }}
    >
      <g id="elv03j6x0xb3">
        <path
          d="M229.103,175.597s26.076,1.032,26.076,0-1.032-24.287,0-24.287-26.076,0-26.076,0v24.287Z"
          style={{
            opacity: 0.3,
            transformOrigin: "242.155px 163.683px",
          }}
          className="animable"
          id="elf396mnmp4c"
        />
      </g>
    </g>
    <g
      id="freepik--Character_1--inject-120"
      className="animable animator-active"
      style={{
        transformOrigin: "162.789px 260.719px",
      }}
    >
      <g
        id="elmezuhrn0h"
        className="animable"
        style={{
          transformOrigin: "162.789px 260.719px",
        }}
      >
        <g
          id="el1tfjb03jh6h"
          className="animable"
          style={{
            transformOrigin: "181.048px 120.879px",
          }}
        >
          <g
            id="el0qk4c87f01dq"
            className="animable"
            style={{
              transformOrigin: "209.226px 132.087px",
            }}
          >
            <path
              d="M220.924,136.007c.204-2.376-6.673-1.083-7.544-1.401,0,0,4.189-.288,6.173-.527,2.73-.771-.534-1.879-1.055-1.685,3.267-2.302-9.266-1.847-9.494-2.464-.795-.465,.068-1.532,.839-2.466,3.344-4.962-2.495-.579-4.629,.512-1.177,.551-1.966,1.645-2.42,2.46l-4.833,.104-.438,7.673,6.663-.403-.014-.101c2.555,1.535,6.898,1.339,10.358,1.274,7.649,.052,2.261-2.409-.456-1.74,.266-.199,6.709-.4,6.849-1.236Z"
              style={{
                fill: "rgb(250, 172, 109)",
                transformOrigin: "209.226px 132.087px",
              }}
              id="elyyovgaz4puh"
              className="animable"
            />
            <g id="eli3cv06rru3s">
              <path
                d="M213.639,132.675c-.064,0-.119-.049-.125-.115-.006-.069,.045-.129,.114-.135,1.536-.125,3.098-.181,4.638-.163,.069,0,.124,.057,.124,.126,0,.068-.057,.124-.125,.124h-.001c-1.531-.017-3.087,.039-4.615,.162h-.01Z"
                style={{
                  opacity: 0.3,
                  transformOrigin: "215.952px 132.467px",
                }}
                className="animable"
                id="elpz2z9z0b0a8"
              />
            </g>
            <g id="el1einbz2r17si">
              <path
                d="M212.657,137.562c-.011,0-.022-.001-.034-.005-.066-.019-.105-.088-.086-.154,.535-1.887,.499-3.956-.102-5.824-.021-.065,.015-.136,.081-.157,.067-.02,.136,.015,.157,.081,.615,1.915,.651,4.034,.104,5.968-.016,.055-.065,.091-.12,.091Z"
                style={{
                  opacity: 0.3,
                  transformOrigin: "212.796px 134.489px",
                }}
                className="animable"
                id="eljemh9pa3yem"
              />
            </g>
            <g id="elhhzyvnd06mm">
              <path
                d="M205.045,133.866c-.068,0-.124-.055-.125-.124s.054-.125,.124-.126c1.597-.021,3.028-1.275,3.259-2.855,.009-.068,.067-.116,.142-.105,.068,.01,.116,.073,.105,.142-.248,1.698-1.787,3.046-3.503,3.069h-.001Z"
                style={{
                  opacity: 0.3,
                  transformOrigin: "206.736px 132.261px",
                }}
                className="animable"
                id="elynlot7upnp"
              />
            </g>
          </g>
          <path
            d="M141.167,101.732c9.556,2.734,32.06,26.036,32.06,26.036l27.74,2.026,1.048,9.092s-28.372,1.662-32.861,.971-25.035-18.699-25.035-18.699l-2.952-19.426Z"
            style={{
              fill: "#213E60",
              transformOrigin: "171.591px 120.879px",
            }}
            id="el14ak6quty1te"
            className="animable"
          />
          <g id="elarw0fjj9rx4">
            <path
              d="M141.167,101.732c9.556,2.734,32.06,26.036,32.06,26.036l27.74,2.026,1.048,9.092s-28.372,1.662-32.861,.971-25.035-18.699-25.035-18.699l-2.952-19.426Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: 0.5,
                transformOrigin: "171.591px 120.879px",
              }}
              className="animable"
              id="elxuw4sv7tacg"
            />
          </g>
        </g>
        <path
          d="M141.167,101.732s10.357,23.079,13.697,64.274l-43.888,3.219c-.797-6.101,.697-36.226-7.492-64.552,4.338-1.2,8.749-2.118,13.206-2.747,5.611-.761,11.261-1.201,16.922-1.316,3.895,.073,3.718,.448,7.555,1.122Z"
          style={{
            fill: "#213E60",
            transformOrigin: "129.174px 134.918px",
          }}
          id="elhmwmwih4u8n"
          className="animable"
        />
        <g id="el6a2log9tlv8">
          <path
            d="M141.167,101.732s10.357,23.079,13.697,64.274l-43.888,3.219c-.797-6.101,.697-36.226-7.492-64.552,4.338-1.2,8.749-2.118,13.206-2.747,5.611-.761,11.261-1.201,16.922-1.316,3.895,.073,3.718,.448,7.555,1.122Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.5,
              transformOrigin: "129.174px 134.918px",
            }}
            className="animable"
            id="elbt8ogbvve7t"
          />
        </g>
        <g
          id="elf7xxzpsavdc"
          className="animable"
          style={{
            transformOrigin: "137.395px 399.443px",
          }}
        >
          <g
            id="elf79ll8o6g8"
            className="animable"
            style={{
              transformOrigin: "92.5845px 399.443px",
            }}
          >
            <polygon
              points="83.522 460.351 73.747 460.377 102.149 338.509 111.422 340.655 83.522 460.351"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "92.5845px 399.443px",
              }}
              id="el1ple1k70c78"
              className="animable"
            />
          </g>
          <g
            id="el89djjxycxen"
            className="animable"
            style={{
              transformOrigin: "193.829px 399.452px",
            }}
          >
            <rect
              x={189.07}
              y={338.541}
              width={9.518}
              height={121.823}
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "193.829px 399.452px",
              }}
              id="elmy7femdzue"
              className="animable"
            />
          </g>
          <g
            id="elbh0egsjygxa"
            className="animable"
            style={{
              transformOrigin: "153.379px 399.452px",
            }}
          >
            <rect
              x={148.62}
              y={338.541}
              width={9.518}
              height={121.823}
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "153.379px 399.452px",
              }}
              id="el5vih59l1yvg"
              className="animable"
            />
            <g id="elx1hj0ro216">
              <rect
                x={148.62}
                y={338.541}
                width={9.518}
                height={121.823}
                style={{
                  fill: "rgb(255, 255, 255)",
                  isolation: "isolate",
                  opacity: 0.1,
                  transformOrigin: "153.379px 399.452px",
                }}
                className="animable"
                id="elljswux00kzi"
              />
            </g>
          </g>
          <g
            id="eld5peybmdy7d"
            className="animable"
            style={{
              transformOrigin: "149.285px 342.683px",
            }}
          >
            <rect
              x={97.526}
              y={338.541}
              width={103.517}
              height={8.285}
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "149.284px 342.683px",
              }}
              id="elhh3ibtjcgye"
              className="animable"
            />
            <g id="elr0gv274y2ie">
              <rect
                x={97.526}
                y={338.541}
                width={103.517}
                height={8.285}
                style={{
                  fill: "rgb(255, 255, 255)",
                  isolation: "isolate",
                  opacity: 0.5,
                  transformOrigin: "149.284px 342.683px",
                }}
                className="animable"
                id="elqjj6j0ia05n"
              />
            </g>
            <g id="el7x9e2rvb6ug">
              <rect
                x={97.971}
                y={338.541}
                width={56.341}
                height={8.285}
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: 0.3,
                  transformOrigin: "126.142px 342.683px",
                }}
                className="animable"
                id="el3izm932a9hr"
              />
            </g>
          </g>
          <g
            id="el16u8t3kd4fz"
            className="animable"
            style={{
              transformOrigin: "127.653px 384.717px",
            }}
          >
            <rect
              x={84.9}
              y={380.574}
              width={85.506}
              height={8.285}
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "127.653px 384.716px",
              }}
              id="elj8vfxqn5vcb"
              className="animable"
            />
            <g id="el0mvoy4sejh3">
              <rect
                x={84.9}
                y={380.574}
                width={85.506}
                height={8.285}
                style={{
                  fill: "rgb(255, 255, 255)",
                  isolation: "isolate",
                  opacity: 0.5,
                  transformOrigin: "127.653px 384.716px",
                }}
                className="animable"
                id="ela3xa4vnrio"
              />
            </g>
            <g id="el74uczfq32e">
              <polyline
                points="84.9 388.859 84.9 380.574 133.3 380.574 133.3 388.859"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: 0.3,
                  transformOrigin: "109.1px 384.717px",
                }}
                className="animable"
                id="elpb96shfge3o"
              />
            </g>
          </g>
          <g
            id="el5dmefom3j5k"
            className="animable"
            style={{
              transformOrigin: "118.038px 428.597px",
            }}
          >
            <rect
              x={73.747}
              y={424.455}
              width={88.582}
              height={8.285}
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "118.038px 428.597px",
              }}
              id="el7497em7sme2"
              className="animable"
            />
            <g id="el04y6umz9zgqo">
              <rect
                x={73.747}
                y={424.455}
                width={88.582}
                height={8.285}
                style={{
                  fill: "rgb(255, 255, 255)",
                  isolation: "isolate",
                  opacity: 0.5,
                  transformOrigin: "118.038px 428.597px",
                }}
                className="animable"
                id="el9akxem9ck9f"
              />
            </g>
            <g id="el6cdeucukhq9">
              <rect
                x={73.747}
                y={424.455}
                width={45.583}
                height={8.285}
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: 0.3,
                  transformOrigin: "96.5385px 428.597px",
                }}
                className="animable"
                id="elh95pob1nxiv"
              />
            </g>
          </g>
          <g
            id="el098ej4kssjyg"
            className="animable"
            style={{
              transformOrigin: "144.979px 399.443px",
            }}
          >
            <polygon
              points="135.917 460.351 126.142 460.377 154.544 338.509 163.817 340.655 135.917 460.351"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "144.979px 399.443px",
              }}
              id="elbicxktltof7"
              className="animable"
            />
            <g id="el8ulusxkmwos">
              <polygon
                points="135.917 460.351 126.142 460.377 154.544 338.509 163.817 340.655 135.917 460.351"
                style={{
                  fill: "rgb(255, 255, 255)",
                  isolation: "isolate",
                  opacity: 0.3,
                  transformOrigin: "144.979px 399.443px",
                }}
                className="animable"
                id="elw9eofp00hlg"
              />
            </g>
          </g>
        </g>
        <g
          id="el83ie6e1kv7b"
          className="animable"
          style={{
            transformOrigin: "153.555px 252.361px",
          }}
        >
          <g
            id="elo7co0hp9wmk"
            className="animable"
            style={{
              transformOrigin: "117.201px 321.783px",
            }}
          >
            <g
              id="elju47v4eou8e"
              className="animable"
              style={{
                transformOrigin: "113.361px 318.938px",
              }}
            >
              <polygon
                points="104.831 327.345 107.629 304.853 121.891 307.853 113.454 333.024 104.831 327.345"
                style={{
                  fill: "#213E60",
                  transformOrigin: "113.361px 318.938px",
                }}
                id="el45pgoflsdli"
                className="animable"
              />
              <g id="elruwuniq340o">
                <polygon
                  points="104.831 327.345 107.629 304.853 121.891 307.853 113.454 333.024 104.831 327.345"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: 0.7,
                    transformOrigin: "113.361px 318.938px",
                  }}
                  className="animable"
                  id="el9a6fuobtjis"
                />
              </g>
            </g>
            <g
              id="el22n02goy3gr"
              className="animable"
              style={{
                transformOrigin: "117.201px 331.106px",
              }}
            >
              <path
                d="M103.492,338.275l7.657,.336s1.187-.591,1.884-.511c.695,.081,3.112,.516,3.112,.516l15.314,.098c-.124-.614-.278-1.16-.454-1.645-.214-.591-.462-1.091-.737-1.515-.966-1.481-2.007-2.091-3.44-2.177-2.183-.131-9.053-4.443-9.053-4.443,0,0-1.69-.693-1.471-3.178,.076-.861,.602-1.663-.946-2.15-1.372-.432-3.577,.497-3.785,1.835-.359,.635-.179,1.334,.029,2.036l-4.631-.964s-3.35-1.586-3.187-.049c.093,.878-1.13,4.457-.777,7.557,.083,.723,.16,1.407,.228,2.007h.002c.151,1.332,.256,2.247,.256,2.247Z"
                style={{
                  fill: "rgb(38, 50, 56)",
                  transformOrigin: "117.201px 331.106px",
                }}
                id="elvvst06gi5ac"
                className="animable"
              />
              <g id="elxqaws8g59v">
                <path
                  d="M131.459,338.714l-15.314-.098s-2.418-.435-3.112-.516c-.697-.08-1.884,.511-1.884,.511l-7.657-.336s-.105-.915-.256-2.247l27.77,1.041c.175,.485,.329,1.031,.454,1.645Z"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: 0.7,
                    transformOrigin: "117.348px 337.371px",
                  }}
                  className="animable"
                  id="elx0m7p1y05w"
                />
              </g>
              <path
                d="M121.196,330.536c-.072-.067-.184-.074-.268-.021-.386,.24-.711,.58-.932,1.007-.116,.225,.233,.442,.351,.215,.196-.379,.48-.679,.818-.89,.113-.07,.131-.218,.034-.307l-.003-.003Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "120.617px 331.157px",
                }}
                id="elhu3j2a2fzi"
                className="animable"
              />
              <path
                d="M119.956,329.849c-.072-.066-.184-.074-.268-.021-.386,.24-.711,.58-.932,1.007-.116,.225,.233,.442,.351,.215,.196-.379,.48-.679,.818-.89,.113-.07,.131-.218,.035-.307l-.003-.003Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "119.377px 330.47px",
                }}
                id="elvo9bmx0rins"
                className="animable"
              />
              <path
                d="M118.676,329.208c-.072-.066-.184-.074-.268-.021-.386,.24-.711,.58-.932,1.007-.116,.225,.233,.442,.351,.215,.196-.379,.48-.679,.818-.89,.113-.071,.131-.218,.034-.308l-.003-.003Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "118.097px 329.829px",
                }}
                id="elcvi69s0x61"
                className="animable"
              />
            </g>
          </g>
          <g
            id="eldfztujtvk9t"
            className="animable"
            style={{
              transformOrigin: "189.859px 322.301px",
            }}
          >
            <g
              id="elvqlmy9j9hfj"
              className="animable"
              style={{
                transformOrigin: "183.188px 319.147px",
              }}
            >
              <polygon
                points="177.493 328.496 175.902 305.887 190.475 306.081 187.049 332.407 177.493 328.496"
                style={{
                  fill: "#213E60",
                  transformOrigin: "183.188px 319.147px",
                }}
                id="el9kd7hd6g9pe"
                className="animable"
              />
              <g id="elhfqsisbki9t">
                <polygon
                  points="177.493 328.496 175.902 305.887 190.475 306.081 187.049 332.407 177.493 328.496"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: 0.7,
                    transformOrigin: "183.188px 319.147px",
                  }}
                  className="animable"
                  id="elzk30eerjzec"
                />
              </g>
            </g>
            <g
              id="elvgi6znq6oj8"
              className="animable"
              style={{
                transformOrigin: "189.859px 331.13px",
              }}
            >
              <path
                d="M176.198,338.513l7.661,.202s1.176-.612,1.875-.544c.696,.068,3.121,.461,3.121,.461l15.313-.17c-.135-.611-.299-1.155-.482-1.636-.224-.587-.481-1.083-.764-1.502-.992-1.464-2.043-2.055-3.478-2.116-2.185-.093-9.129-4.284-9.129-4.284,0,0-1.701-.663-1.527-3.152,.06-.863,.573-1.673-.984-2.133-1.38-.408-3.568,.56-3.752,1.901-.347,.642-.156,1.337,.064,2.035l-4.647-.883s-3.377-1.527-3.188,.007c.108,.876-1.052,4.476-.645,7.57,.096,.721,.184,1.404,.263,2.002h.001c.174,1.329,.296,2.242,.296,2.242Z"
                style={{
                  fill: "rgb(38, 50, 56)",
                  transformOrigin: "189.859px 331.13px",
                }}
                id="elv7nbd26scz8"
                className="animable"
              />
              <g id="eljxuq0ofyizq">
                <path
                  d="M204.168,338.462l-15.313,.17s-2.425-.393-3.121-.461c-.698-.068-1.875,.544-1.875,.544l-7.662-.202s-.121-.913-.296-2.242l27.784,.555c.184,.482,.347,1.025,.482,1.636Z"
                  style={{
                    fill: "rgb(255, 255, 255)",
                    opacity: 0.7,
                    transformOrigin: "190.034px 337.493px",
                  }}
                  className="animable"
                  id="el27kkqcpqkyv"
                />
              </g>
              <path
                d="M193.763,330.465c-.073-.065-.185-.071-.268-.017-.382,.247-.701,.593-.914,1.023-.112,.227,.241,.438,.354,.209,.189-.382,.468-.688,.802-.904,.111-.072,.128-.22,.029-.308l-.003-.003Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "193.195px 331.095px",
                }}
                id="el234ioqpymxc"
                className="animable"
              />
              <path
                d="M192.511,329.8c-.073-.065-.185-.071-.268-.017-.382,.247-.701,.593-.914,1.023-.112,.227,.241,.438,.354,.209,.189-.382,.468-.688,.802-.904,.111-.073,.128-.221,.029-.308l-.003-.003Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "191.943px 330.43px",
                }}
                id="el7bttse3s9p3"
                className="animable"
              />
              <path
                d="M191.221,329.181c-.073-.065-.185-.071-.268-.017-.382,.247-.701,.593-.914,1.023-.112,.227,.241,.438,.355,.209,.189-.382,.468-.688,.802-.904,.112-.073,.128-.221,.029-.308l-.003-.003Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "190.654px 329.811px",
                }}
                id="el135rw1bcs5t"
                className="animable"
              />
            </g>
          </g>
          <path
            d="M103.236,319.808l16.785,3.618s16.61-56.205,18.891-70.236,1.158-48.033,1.158-48.033h0l-.003,.058c.519,.793,5.093,8.098,10.349,16.564,6.869,11.103,14.925,24.216,16.585,27.41,4.912,9.405,7.697,73.827,7.697,73.827l18.839,.13s1.124-56.098-4.475-76.415c-5.599-20.317-33.876-75.264-33.876-75.264l-.323-5.461-43.942,3.158s.113,6.719-.185,12.571c-1.106,21.956,4.748,52.074,4.948,60.081,.407,15.286-12.449,77.992-12.449,77.992Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "148.432px 244.716px",
            }}
            id="el11dmvmybqpy9"
            className="animable"
          />
        </g>
        <g id="el4c0evbdcyov">
          <path
            d="M140.068,205.181h0l-.003,.057c.519,.793,5.093,8.098,10.349,16.564,1.687-8.955-2.731-21.403-10.349-26.404l.003,9.783Z"
            style={{
              isolation: "isolate",
              opacity: 0.2,
              transformOrigin: "145.418px 208.6px",
            }}
            className="animable"
            id="elk1vdofn04co"
          />
        </g>
        <g
          id="ellzfukpllpgf"
          className="animable"
          style={{
            transformOrigin: "122.327px 85.1238px",
          }}
        >
          <path
            d="M116.853,83.808c1.663,5.309,3.824,15.141,.431,19.193,5.45,1.626,9.361,2.711,14.217,6.185,1.2-3.511,1.371-8.292,1.371-8.292-4.733-.59-5.266-5.051-4.677-9.36l-11.342-7.726Z"
            style={{
              fill: "rgb(250, 172, 109)",
              transformOrigin: "124.862px 96.497px",
            }}
            id="elia5znskfyy"
            className="animable"
          />
          <g id="elac44zzj6j3">
            <path
              d="M121.475,86.945l6.665,4.551c-.146,1.01-.206,2.031-.179,3.051-2.307-.066-5.806-2.259-6.323-4.658-.233-.963-.287-1.961-.162-2.944Z"
              style={{
                isolation: "isolate",
                opacity: 0.2,
                transformOrigin: "124.775px 90.746px",
              }}
              className="animable"
              id="el4okditu70wm"
            />
          </g>
          <path
            d="M131.785,66.246c1.918,1.625,2.247,5.471,2.624,7.838,.353,2.216,.948,5.093-2.202,2.285s-7.264-15.181-.421-10.123Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "131.385px 71.2887px",
            }}
            id="elk8luvnhs5ib"
            className="animable"
          />
          <g id="elm8ccjx037c">
            <path
              d="M119.185,92.267s3.099,5.333,9.192,4.737c-.674-2.409-.236-4.549,.069-5.884-.47-.142,.078-.855,.078-.855l-9.339,2.001Z"
              style={{
                isolation: "isolate",
                opacity: 0.2,
                transformOrigin: "123.854px 93.6577px",
              }}
              className="animable"
              id="elbhvj67snsqb"
            />
          </g>
          <path
            d="M119.198,92.655c3.959,2.595,8.276,3.006,11.739,.827,2.228-1.398,3.978-3.651,4.704-6.423,.099-.363,.175-.74,.238-1.124,1.054-7.032-.973-18.323-8.744-20.726-5.53-1.752-11.447,1.312-13.197,6.851-.509,1.572-.623,3.245-.36,4.881,1.108,7.611,.995,12.681,5.62,15.713Z"
            style={{
              fill: "rgb(250, 172, 109)",
              transformOrigin: "124.789px 79.8023px",
            }}
            id="elqo1t2f7jp9"
            className="animable"
          />
          <path
            d="M125.378,78.519c.013,.802,.545,1.417,1.079,1.37,.534-.047,.892-.74,.828-1.541-.064-.801-.558-1.417-1.079-1.371-.521,.047-.892,.728-.828,1.542Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "126.332px 78.4331px",
            }}
            id="el05ppdno0wu27"
            className="animable"
          />
          <path
            d="M132.4,78.037c.013,.802,.558,1.417,1.079,1.371,.521-.047,.892-.74,.828-1.542-.064-.801-.558-1.417-1.079-1.37-.521,.047-.891,.778-.828,1.541Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "133.354px 77.952px",
            }}
            id="elatizkk8xrat"
            className="animable"
          />
          <path
            d="M130.23,77.973c.907,1.844,2.065,3.554,3.441,5.081-.814,.695-1.894,.995-2.95,.818l-.491-5.899Z"
            style={{
              fill: "rgb(233, 127, 63)",
              transformOrigin: "131.95px 80.9474px",
            }}
            id="el0npzxkw67b8"
            className="animable"
          />
          <path
            d="M134.8,74.235c-.114,.077-.26,.087-.383,.027-.823-.445-1.806-.475-2.655-.082-.175,.101-.398,.041-.499-.134-.101-.175-.041-.398,.134-.499h.001c1.06-.525,2.308-.503,3.348,.058,.182,.087,.26,.304,.174,.487l-.004,.008c-.031,.051-.071,.096-.116,.135Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "133.084px 73.7345px",
            }}
            id="elkpv581i69bc"
            className="animable"
          />
          <path
            d="M123.754,75.381c-.074,.004-.147-.015-.21-.055-.146-.14-.151-.371-.012-.517l.006-.006c.813-.864,1.996-1.277,3.17-1.109,.198,.04,.325,.233,.285,.431h0c-.045,.196-.235,.321-.432,.286h0c-.93-.106-1.856,.235-2.497,.918-.091,.062-.204,.081-.31,.052Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "125.216px 74.5257px",
            }}
            id="ell3l03tl80ic"
            className="animable"
          />
          <g
            id="eluvvifmf3sho"
            className="animable"
            style={{
              transformOrigin: "126.18px 85.5805px",
            }}
          >
            <path
              d="M127.97,85.147c-1.48-.316-2.875-.942-4.094-1.839-.112,.235-.188,.486-.227,.743-.082,.456-.051,.926,.091,1.367,.29,.902,1.137,1.851,3.325,2.332,.16,.044,.322,.079,.486,.106,.34-.872,.743-1.718,1.205-2.532,0,0-.298-.054-.786-.178Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "126.18px 85.582px",
              }}
              id="el9971g8pmf9"
              className="animable"
            />
            <path
              d="M123.913,83.305c-.112,.235-.188,.486-.227,.743,.502,.769,1.888,1.368,3.947,1.84l.375-.744c-1.48-.315-2.876-.942-4.094-1.839Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "125.847px 84.5965px",
              }}
              id="ell88ubusi4ca"
              className="animable"
            />
            <path
              d="M126.065,86.434c-.709-.473-1.497-.817-2.325-1.016,.29,.902,1.137,1.851,3.325,2.332-.188-.532-.537-.993-1-1.316Z"
              style={{
                fill: "rgb(253, 80, 78)",
                transformOrigin: "125.403px 86.584px",
              }}
              id="elvfgtpd0yi3k"
              className="animable"
            />
          </g>
          <path
            d="M129.541,61.377c-5.42-1.359-18.462,1.953-19.774,4.614-.641,1.123-.728,2.467-.26,3.653-2.857,2.778,.775,14.266,6.912,13.491,3.911-.486,3.214-2.006,2.958-2.356-1.17-1.513-.263-3.978,.675-7.158,.37-1.253-.42-2.461-1.768-3.368,1.793-2.218,4.962-2.923,7.567-1.525,0,0,4.405,2.304,6.453-2.856,.08-.226,.136-.46,.167-.698,.239-1.857-1.072-3.557-2.929-3.797Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "120.508px 72.117px",
            }}
            id="el3fkxb0tw4h"
            className="animable"
          />
          <g
            id="eljle3cm0hyyc"
            className="animable"
            style={{
              transformOrigin: "114.31px 82.6596px",
            }}
          >
            <path
              d="M110.773,83.513c.999,1.66,2.616,2.856,4.497,3.326,2.494,.604,3.652-1.65,2.891-3.961-.696-2.047-2.826-4.899-5.297-4.45-2.471,.449-3.291,3.032-2.09,5.086Z"
              style={{
                fill: "rgb(250, 172, 109)",
                transformOrigin: "114.31px 82.6596px",
              }}
              id="elr5qvnwsz9a"
              className="animable"
            />
            <g id="elsywzd3bl6zo">
              <path
                d="M116.313,83.598c-.303-1.206-1.154-2.245-2.276-2.781-.422-.201-.981-.311-1.281-.013l-.353-.354c.411-.409,1.102-.439,1.849-.083,1.255,.6,2.207,1.762,2.546,3.11l-.485,.122Z"
                style={{
                  opacity: 0.1,
                  transformOrigin: "114.601px 81.8595px",
                }}
                className="animable"
                id="else28x7n1c4j"
              />
            </g>
          </g>
        </g>
        <g id="el7de3krkwhr">
          <path
            d="M118.673,168.603l-7.696,.61c-.474-3.725-.105-16.493-1.634-32.342,3.142-7.071,4.966-16.782,4.966-16.782,4.876,6.962,10.346,16.663,13.864,23.493,4.245,8.175-1.109,19.842-9.501,25.021Z"
            style={{
              isolation: "isolate",
              opacity: 0.1,
              transformOrigin: "119.502px 144.651px",
            }}
            className="animable"
            id="eln9z3qn9gh4c"
          />
        </g>
        <g
          id="elp8452ooh2bp"
          className="animable"
          style={{
            transformOrigin: "205.045px 132.086px",
          }}
        >
          <g
            id="el4t57mb5rt0h"
            className="animable"
            style={{
              transformOrigin: "205.045px 132.086px",
            }}
          >
            <polygon
              points="177.688 93.723 175.105 93.723 158.259 93.723 158.259 170.449 175.105 170.449 177.688 170.449 251.831 170.449 251.831 93.723 177.688 93.723"
              style={{
                fill: "#213E60",
                transformOrigin: "205.045px 132.086px",
              }}
              id="elekysy9ftfa"
              className="animable"
            />
            <path
              d="M233.582,139.766c0,6.55-4.967,10.316-14.627,10.316h-18.23v-38.207h17.138c8.788,0,13.7,3.711,13.7,9.879,0,4.148-2.128,7.041-5.13,8.514,4.312,1.201,7.15,4.421,7.15,9.497Zm-27.399-23.47v12.226h11.189c5.567,0,8.733-2.074,8.733-6.113s-3.166-6.113-8.733-6.113h-11.189Zm21.887,23.033c0-4.421-3.274-6.386-9.333-6.386h-12.554v12.717h12.554c6.059,0,9.333-1.911,9.333-6.332Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "217.154px 130.979px",
              }}
              id="ellok2c5jgkko"
              className="animable"
            />
          </g>
          <g id="el09heuy41tjoa">
            <rect
              x={158.259}
              y={93.724}
              width={19.429}
              height={76.726}
              style={{
                opacity: 0.3,
                transformOrigin: "167.973px 132.087px",
              }}
              className="animable"
              id="ela7z6pmfuyg"
            />
          </g>
        </g>
        <g
          id="elviexi3x7u5m"
          className="animable"
          style={{
            transformOrigin: "124.33px 103.961px",
          }}
        >
          <path
            d="M115.283,103.05s3.166-6.028,3.583-5.999c.418,.029,9.257,4.044,9.257,4.044l.626-3.647,4.627,3.555-1.561,9.869-16.532-7.822Z"
            style={{
              fill: "#213E60",
              transformOrigin: "124.33px 103.961px",
            }}
            id="elup74y28woh"
            className="animable"
          />
          <g id="el3rstxgicov9">
            <path
              d="M115.283,103.05s3.166-6.028,3.583-5.999c.418,.029,9.257,4.044,9.257,4.044l.626-3.647,4.627,3.555-1.561,9.869-16.532-7.822Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: 0.5,
                transformOrigin: "124.33px 103.961px",
              }}
              className="animable"
              id="elhckuvsbx6g5"
            />
          </g>
          <g id="elqnwlma2s2mj">
            <path
              d="M115.814,102.054s9.507,5.746,9.557,5.769c.05,.024,1.982-4.413,1.982-4.413l-1.173,5.776-10.366-7.132Z"
              style={{
                isolation: "isolate",
                opacity: 0.1,
                transformOrigin: "121.584px 105.62px",
              }}
              className="animable"
              id="eltj9dkomp6fs"
            />
          </g>
        </g>
        <path
          d="M127.42,103.473l-.839,2.988,1.684,2.634c1.697,.126,11.033,42.845,7.284,58.84l8.873,5.561,2.649-6.137c.76-13.596-10.719-53.037-16.567-58.85l.788-3.8h0l-2.328-1.702-1.543,.466Z"
          style={{
            fill: "#213E60",
            transformOrigin: "136.844px 138.252px",
          }}
          id="eldr0mjaraldk"
          className="animable"
        />
        <g
          id="elx39ejk85xh"
          className="animable"
          style={{
            transformOrigin: "134.622px 131.428px",
          }}
        >
          <g
            id="elyc4ue3xtpj"
            className="animable"
            style={{
              transformOrigin: "128.714px 130.403px",
            }}
          >
            <path
              d="M103.483,104.673c-10.741,5.827,4.55,40.52,7.547,45.746,2.997,5.225,46.69,5.714,46.69,5.714l-.381-10.095-35.303-4.77-8.895-26.75c-3.565-8.54-9.658-9.845-9.658-9.845Z"
              style={{
                fill: "#213E60",
                transformOrigin: "128.714px 130.403px",
              }}
              id="elecdiw90idmv"
              className="animable"
            />
            <g id="elc1iy94x5dxw">
              <path
                d="M103.483,104.673c-10.741,5.827,4.55,40.52,7.547,45.746,2.997,5.225,46.69,5.714,46.69,5.714l-.381-10.095-35.303-4.77-8.895-26.75c-3.565-8.54-9.658-9.845-9.658-9.845Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: 0.5,
                  transformOrigin: "128.714px 130.403px",
                }}
                className="animable"
                id="eli435envrza"
              />
            </g>
          </g>
          <g
            id="elq3c35tlira8"
            className="animable"
            style={{
              transformOrigin: "163.142px 150.619px",
            }}
          >
            <path
              d="M160.247,146.657s7.212,1.063,8.062,2.579c.85,1.516-1.63,1.583-1.63,1.583,0,0,2.734,.095,2.85,1.261,.14,1.4-2.459,1.457-2.459,1.457,0,0,2.229,.169,2.263,1.213,.035,1.083-2.893,1.357-2.893,1.357,0,0,1.547,.416,1.16,1.155-.387,.739-6.581,1.42-8.512,.414-1.927-1.004-2.725-7.913-2.163-10.459,.385-1.744,1.613-3.839,3.321-4.161v3.6h0Z"
              style={{
                fill: "rgb(250, 172, 109)",
                transformOrigin: "163.142px 150.619px",
              }}
              id="elpj7ipc5k1y"
              className="animable"
            />
            <g id="elu8y1ppfhhx">
              <path
                d="M167.076,150.753h-.011l-4.758-.394c-.064-.006-.112-.069-.108-.141,.004-.073,.062-.128,.123-.122l4.758,.394c.064,.005,.112,.069,.108,.141-.004,.068-.053,.12-.112,.122Z"
                style={{
                  opacity: 0.2,
                  transformOrigin: "164.694px 150.424px",
                }}
                className="animable"
                id="el7jlsw787n"
              />
            </g>
            <g id="eluty0zemakj">
              <path
                d="M167.332,153.475h-.003l-4.6-.014c-.064,0-.116-.059-.116-.132,0-.073,.042-.119,.116-.131l4.6,.014c.064,0,.116,.059,.116,.132,0,.072-.05,.13-.113,.131Z"
                style={{
                  opacity: 0.2,
                  transformOrigin: "165.029px 153.337px",
                }}
                className="animable"
                id="el96iopwx0v2"
              />
            </g>
            <g id="eledkd0u3xd68">
              <path
                d="M166.68,156.045l-3.418,.087c-.064,.002-.117-.056-.119-.129-.002-.072,.048-.133,.112-.135l3.419-.087c.064-.002,.117,.056,.119,.129,.002,.073-.048,.133-.112,.135Z"
                style={{
                  opacity: 0.2,
                  transformOrigin: "164.968px 155.957px",
                }}
                className="animable"
                id="eleu41r0gahxc"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
    <defs>
      <filter id="active" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter id="hover" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#ff0000" floodOpacity={0.5} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
        <feColorMatrix
          type="matrix"
          values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
        />
      </filter>
    </defs>
  </svg>
);
export default BrandPromotionSVG;
